import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import UnreadBadge from '../../components/CoverFlow/UnreadBadge';
import DriveItemUtils from '../../utils/driveItem';
import RouteUtils from '../../utils/routes';

interface UnreadBadgeOwnProps {
	id: number;
}

const mapStateToProps = (state: StoreState, { id }: UnreadBadgeOwnProps) => {
	const {
		driveList,
		readStatus,
		routerParamsHistory,
	} = state;

	return {
		isUnread: ['new', 'downloads'].includes(RouteUtils.getCurrentOrigin(routerParamsHistory)) && DriveItemUtils.isUnread(driveList, readStatus, id),
	};
};

export default connect(mapStateToProps)(UnreadBadge);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CoverFlow/UnreadBadge.tsx